import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { computed, defineComponent, onMounted, ref, toRefs, watch } from "@vue/composition-api";
import InlinePrompt from "@Shared/components/general/inline-prompt.vue";
import TextSection from "@Shared/components/sections/text-section.vue";
import Field from "@Shared/components/sections/field.vue";
import NotificationPopover from "@Shared/components/general/notification-popover.vue";
import { useI18n } from "vue-i18n-composable";
import * as LenderSubmitGetters from "@Broker/@Modules/clients/applications/application/store/lender-submit-getters";
import * as LenderSubmitActions from "@Broker/@Modules/clients/applications/application/store/lender-submit-actions";
import { useApplicationStoreGetters, useApplicationStoreActions } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
import { validationMixin } from "vuelidate";
import { useVuelidate } from "@Shared/@Composables/validations/useVuelidate";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import PercentageInput from "@Shared/components/inputs/percentage-input.vue";
export default defineComponent({
  name: "CommissionDetailsTable",
  components: {
    InlinePrompt,
    Field,
    TextSection,
    NotificationPopover,
    MaterialInput,
    PercentageInput
  },
  mixins: [validationMixin],
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    mortgageType: {
      type: String,
      required: true
    },
    participants: {
      type: Array,
      required: true
    },
    totalNetFees: {
      type: Number,
      required: true
    },
    deductions: {
      type: Number,
      default: 0
    },
    isReadOnly: {
      type: Boolean,
      required: true
    }
  },
  validations: {
    participants: {
      $each: {
        commissionSplitTotal() {
          return !this.showAgentSplitError;
        }
      }
    }
  },
  setup(props) {
    const {
      v$
    } = useVuelidate();
    const {
      t
    } = useI18n();
    const tableColumns = ref(["agents", "primaryContact", "firmAgentSplit", "agentSplit", "fees", "netFees", "actions"]);
    const {
      applicationId,
      clientUsername,
      mortgageType,
      participants,
      totalNetFees,
      deductions
    } = toRefs(props);
    const commissionDetailsTable = ref({});
    const agentsPercentage = ref(0);
    const options = computed(() => {
      return {
        sortable: [],
        filterable: false,
        showChildRowToggler: false,
        perPage: 999999,
        selectable: {
          mode: "single",
          programmatic: true
        },
        headings: {
          agents: t("global.words.agent"),
          primaryContact: t("direct-to-lender.commissions.commissionDetails.primaryContact"),
          firmAgentSplit: t("direct-to-lender.commissions.commissionDetails.firmAgentSplit"),
          agentSplit: t("direct-to-lender.commissions.commissionDetails.agentSplit"),
          fees: t("direct-to-lender.navigation.fees"),
          netFees: t("direct-to-lender.commissions.commissionDetails.netFees"),
          actions: t("global.words.actions")
        },
        columnsClasses: {
          agents: "w-25 hidden-heading",
          primaryContact: "w-10",
          firmAgentSplit: "w-15",
          agentSplit: "w-15",
          fees: "w-15",
          netFees: "w-15",
          actions: "w-5 hidden-heading"
        },
        tabbable: false,
        skin: "table table-hover"
      };
    });
    const agentsSplit = computed(() => {
      return totalNetFees.value * (agentsPercentage.value / 100);
    });
    const showAgentSplitError = computed(() => {
      return !IS_AGENTS_SPLIT_SUMMARY_COMPLETED.value(applicationId.value);
    });
    const {
      GET_COMMISSION_DETAILS_FIRM_PERCENTAGE,
      IS_AGENTS_SPLIT_SUMMARY_COMPLETED
    } = useApplicationStoreGetters([LenderSubmitGetters.GET_COMMISSION_DETAILS_FIRM_PERCENTAGE, LenderSubmitGetters.IS_AGENTS_SPLIT_SUMMARY_COMPLETED]);
    const {
      UPDATE_COMMISSIONS_DETAILS,
      UPDATE_COMMISSIONS_DETAILS_PARTICIPANT,
      UPDATE_COMMISSIONS_DETAILS_PRIMARY_CONTACT,
      REMOVE_COMMISSIONS_DETAILS_PARTICIPANT
    } = useApplicationStoreActions([LenderSubmitActions.UPDATE_COMMISSIONS_DETAILS, LenderSubmitActions.UPDATE_COMMISSIONS_DETAILS_PARTICIPANT, LenderSubmitActions.UPDATE_COMMISSIONS_DETAILS_PRIMARY_CONTACT, LenderSubmitActions.REMOVE_COMMISSIONS_DETAILS_PARTICIPANT]);
    const firmPercentage = computed(() => {
      return GET_COMMISSION_DETAILS_FIRM_PERCENTAGE.value(applicationId.value);
    });
    const firmFees = computed(() => Number(totalNetFees.value) * Number(firmPercentage.value) / 100);
    const tableData = computed(() => {
      return [{
        isFirm: true,
        fees: firmFees.value,
        netFees: firmFees.value
      }, ...participants.value];
    });
    const changePrimaryContact = async participant => {
      return UPDATE_COMMISSIONS_DETAILS_PRIMARY_CONTACT({
        applicationId: applicationId.value,
        clientUsername: clientUsername.value,
        participant
      });
    };
    const changeFirmPercentage = (rate, save = true) => {
      rate = getMinOr100(rate);
      UPDATE_COMMISSIONS_DETAILS({
        applicationId: applicationId.value,
        clientUsername: clientUsername.value,
        mortgageType: mortgageType.value,
        commissionsDetails: {
          firmSplit: Number(rate)
        },
        save
      });
    };
    const changeAgentsPercentage = rate => {
      agentsPercentage.value = getMinOr100(rate);
      UPDATE_COMMISSIONS_DETAILS({
        applicationId: applicationId.value,
        clientUsername: clientUsername.value,
        mortgageType: mortgageType.value,
        commissionsDetails: {
          firmSplit: 100 - Number(agentsPercentage.value)
        }
      });
    };
    const getMinOr100 = value => {
      return value > 100 ? 100 : value;
    };
    const handleChangeAgentSplit = (participant, splitRate, isAgent, save = true) => {
      const splitRateParsed = Number(splitRate);
      const fees = calculateAgentSplit(splitRateParsed);
      const formattedParticipant = _objectSpread(_objectSpread({}, participant), {}, {
        agentSplit: splitRateParsed,
        fees,
        netFees: calculateNetFee(fees, isAgent)
      });
      UPDATE_COMMISSIONS_DETAILS_PARTICIPANT({
        applicationId: applicationId.value,
        clientUsername: clientUsername.value,
        participant: formattedParticipant,
        save
      });
    };
    onMounted(() => {
      changeFirmPercentage(firmPercentage.value, false);
      if (participants.value.length === 1) {
        const participant = participants.value[0];
        handleChangeAgentSplit(participant, 100, true, false);
      }
    });
    watch([agentsPercentage, totalNetFees], () => {
      participants.value.forEach((participant, index) => {
        handleChangeAgentSplit(participant, participant.agentSplit, index === 0, false);
      });
    });
    watch(firmPercentage, () => {
      agentsPercentage.value = 100 - firmPercentage.value;
    }, {
      immediate: true
    });
    const calculateAgentSplit = rate => {
      return agentsSplit.value * (rate / 100);
    };
    const getParticipantName = row => {
      return row.agentDetailsEB ? `${row.agentDetailsEB.firstName} ${row.agentDetailsEB.lastName}` : `${row.givenName} ${row.familyName}`;
    };
    const calculateNetFee = (fees, isAgent) => {
      return isAgent ? fees - deductions.value : fees;
    };
    const handleRemoveParticipant = async participant => {
      if (participant.primaryContact) {
        await changePrimaryContact(participants.value[0]);
      }
      REMOVE_COMMISSIONS_DETAILS_PARTICIPANT({
        applicationId: applicationId.value,
        clientUsername: clientUsername.value,
        commissionsParticipantId: participant.commissionsParticipantId
      });
    };
    return {
      tableColumns,
      options,
      tableData,
      commissionDetailsTable,
      firmPercentage,
      agentsPercentage,
      agentsSplit,
      showAgentSplitError,
      firmFees,
      getParticipantName,
      changePrimaryContact,
      changeFirmPercentage,
      changeAgentsPercentage,
      handleChangeAgentSplit,
      calculateAgentSplit,
      calculateNetFee,
      handleRemoveParticipant,
      v$
    };
  }
});